import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'pa-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {

  @Input('description') description: string;
  @Input('width') width: number = 513;

  @Output() messageState = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
  }

  close() {
    this.description = null;
    this.messageState.emit(null);
  }
}
